import action from 'utils/actionCreators';

export const GET_SEGMENT_REQUEST = 'GET_SEGMENT_REQUEST';
export const GET_SEGMENT_SUCCESS = 'GET_SEGMENT_SUCCESS';
export const GET_SEGMENT_FAILURE = 'GET_SEGMENT_FAILURE';

export const GET_SEGMENT_BY_ID_REQUEST = 'GET_SEGMENT_BY_ID_REQUEST';
export const GET_SEGMENT_BY_ID_SUCCESS = 'GET_SEGMENT_BY_ID_SUCCESS';
export const GET_SEGMENT_BY_ID_FAILURE = 'GET_SEGMENT_BY_ID_FAILURE';

export const ADD_SEGMENT_REQUEST = 'ADD_SEGMENT_REQUEST';
export const ADD_SEGMENT_SUCCESS = 'ADD_SEGMENT_SUCCESS';
export const ADD_SEGMENT_FAILURE = 'ADD_SEGMENT_FAILURE';

export const UPDATE_SEGMENT_REQUEST = 'UPDATE_SEGMENT_REQUEST';
export const UPDATE_SEGMENT_SUCCESS = 'UPDATE_SEGMENT_SUCCESS';
export const UPDATE_SEGMENT_FAILURE = 'UPDATE_SEGMENT_FAILURE';

export const DELETE_SEGMENT_REQUEST = 'DELETE_SEGMENT_REQUEST';
export const DELETE_SEGMENT_SUCCESS = 'DELETE_SEGMENT_SUCCESS';
export const DELETE_SEGMENT_FAILURE = 'DELETE_SEGMENT_FAILURE';

export const GET_SUB_SEGMENT_REQUEST = 'GET_SUB_SEGMENT_REQUEST';
export const GET_SUB_SEGMENT_SUCCESS = 'GET_SUB_SEGMENT_SUCCESS';
export const GET_SUB_SEGMENT_FAILURE = 'GET_SUB_SEGMENT_FAILURE';

export const GET_SUB_SEGMENT_BY_ID_REQUEST = 'GET_SUB_SEGMENT_BY_ID_REQUEST';
export const GET_SUB_SEGMENT_BY_ID_SUCCESS = 'GET_SUB_SEGMENT_BY_ID_SUCCESS';
export const GET_SUB_SEGMENT_BY_ID_FAILURE = 'GET_SUB_SEGMENT_BY_ID_FAILURE';

export const ADD_SUB_SEGMENT_REQUEST = 'ADD_SUB_SEGMENT_REQUEST';
export const ADD_SUB_SEGMENT_SUCCESS = 'ADD_SUB_SEGMENT_SUCCESS';
export const ADD_SUB_SEGMENT_FAILURE = 'ADD_SUB_SEGMENT_FAILURE';

export const UPDATE_SUB_SEGMENT_REQUEST = 'UPDATE_SUB_SEGMENT_REQUEST';
export const UPDATE_SUB_SEGMENT_SUCCESS = 'UPDATE_SUB_SEGMENT_SUCCESS';
export const UPDATE_SUB_SEGMENT_FAILURE = 'UPDATE_SUB_SEGMENT_FAILURE';

export const DELETE_SUB_SEGMENT_REQUEST = 'DELETE_SUB_SEGMENT_REQUEST';
export const DELETE_SUB_SEGMENT_SUCCESS = 'DELETE_SUB_SEGMENT_SUCCESS';
export const DELETE_SUB_SEGMENT_FAILURE = 'DELETE_SUB_SEGMENT_FAILURE';

export const OPEN_FORM_MODAL = 'SEGMENT/OPEN_FORM_MODAL';
export const CLOSE_FORM_MODAL = 'SEGMENT/CLOSE_FORM_MODAL';

export const OPEN_CONFIRMATION_MODAL = 'SEGMENT/OPEN_CONFIRMATION_MODAL';
export const CLOSE_CONFIRMATION_MODAL = 'SEGMENT/CLOSE_CONFIRMATION_MODAL';

export const UPDATE_FORM_FIELD = 'SEGMENT/UPDATE_FORM_FIELD';
export const RESET_FORM_FIELD = 'SEGMENT/RESET_FORM_FIELD';

export const UPDATE_SEARCH_TEXT = 'SEGMENT/UPDATE_SEARCH_TEXT';

export const getSegmentRequest = action(GET_SEGMENT_REQUEST, 'payload');

export const getSegmentByIdRequest = action(
  GET_SEGMENT_BY_ID_REQUEST,
  'payload',
);

export const addSegmentRequest = action(ADD_SEGMENT_REQUEST, 'payload');

export const updateSegmentRequest = action(UPDATE_SEGMENT_REQUEST, 'payload');

export const deleteSegmentRequest = action(DELETE_SEGMENT_REQUEST, 'payload');

export const getSubSegmentRequest = action(GET_SUB_SEGMENT_REQUEST, 'payload');

export const getSubSegmentByIdRequest = action(
  GET_SUB_SEGMENT_BY_ID_REQUEST,
  'payload',
);

export const addSubSegmentRequest = action(ADD_SUB_SEGMENT_REQUEST, 'payload');

export const updateSubSegmentRequest = action(
  UPDATE_SUB_SEGMENT_REQUEST,
  'payload',
);

export const deleteSubSegmentRequest = action(
  DELETE_SUB_SEGMENT_REQUEST,
  'payload',
);
export const openFormModal = action(OPEN_FORM_MODAL);
export const closeFormModal = action(CLOSE_FORM_MODAL);

export const openConfirmationModal = action(OPEN_CONFIRMATION_MODAL, 'payload');
export const closeConfirmationModal = action(CLOSE_CONFIRMATION_MODAL);

export const updateFormField = action(UPDATE_FORM_FIELD, 'payload');
export const resetFormField = action(RESET_FORM_FIELD);

export const updateSearchText = action(UPDATE_SEARCH_TEXT, 'payload');
